<form #form="ngForm" novalidate *ngIf="entity">

  <!-- E-mails -->
  <div class="mb-3">
    <sgt-accordion [settings]="{ isCollapsed: true }">
      <h6 header class="m-0">E-mails</h6>
  
      <div class="row">
        <div class="form-group col-12 col-md-6">
          <label for="emailNfe" class="col-form-label">E-mail NF-e</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <a href="mailto:{{entity.emailNfe}}" class="btn btn-light" tabindex="-1">
                <i class="far fa-envelope" aria-hidden="true"></i>
              </a>
            </div>
            <input type="email" class="form-control" [(ngModel)]="entity.emailNfe" name="emailNfe" id="emailNfe"
              #emailNfe="ngModel" maxlength="100" [required]="isEmailNfeRequired()" [disabled]="!canEdit" [readonly]="!canEdit" sgtLowercase>
          </div>
          <sgt-form-control-error
            *ngIf="emailNfe.errors && emailNfe.errors.required && emailNfe.dirty"
            msgError="O e-mail NF-e é obrigatório">
          </sgt-form-control-error>
          <sgt-form-control-error
            *ngIf="emailNfe.errors && emailNfe.errors.maxlength"
            msgError="O e-mail NF-e deve ter no máximo 100 caracteres">
          </sgt-form-control-error>
        </div>
      </div>
  
      <div class="row" *ngIf="configCliente?.exibirLaudo">
        <div class="form-group col-12 col-md-6">
          <label class="col-form-label">Enviar Laudo?</label>
          <br/>
          <div class="custom-control custom-radio custom-control-inline">
            <input type="radio" class="custom-control-input" name="laudo" id="laudoSim" [value]="true" [(ngModel)]="entity.laudo"
              #laudo="ngModel" [required]="isLaudoRequired()" [attr.disabled]="!canEdit || null" [attr.readonly]="!canEdit || null">
            <label class="custom-control-label" for="laudoSim">Sim</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input type="radio" class="custom-control-input" name="laudo" id="laudoNao" [value]="false" [(ngModel)]="entity.laudo"
              [required]="isLaudoRequired()" [attr.disabled]="!canEdit || null" [attr.readonly]="!canEdit || null">
            <label class="custom-control-label" for="laudoNao">Não</label>
          </div>
          <sgt-form-control-error
            *ngIf="laudo.errors && laudo.errors.required && laudo.dirty"
            msgError="É obrigatório informar se deve ou não enviar laudo">
          </sgt-form-control-error>
          <p class="form-text text-muted">
            Selecione Sim se o cliente deseja o envio do laudo
          </p>
        </div>
        <div class="form-group col-12 col-md-6">
          <label for="emailLaudo" class="col-form-label">E-mail Laudo</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <a href="mailto:{{entity.emailLaudo}}" class="btn btn-light" tabindex="-1">
                <i class="far fa-envelope" aria-hidden="true"></i>
              </a>
            </div>
            <input type="email" class="form-control" [(ngModel)]="entity.emailLaudo" name="emailLaudo" id="emailLaudo"
              #emailLaudo="ngModel" maxlength="100" [required]="entity.laudo" [disabled]="!canEdit" [readonly]="!canEdit" sgtLowercase>
          </div>
          <sgt-form-control-error
            *ngIf="emailLaudo.errors && emailLaudo.errors.required && emailLaudo.dirty"
            msgError="O e-mail laudo é obrigatório quando selecionado para enviar o laudo">
          </sgt-form-control-error>
          <sgt-form-control-error
            *ngIf="emailLaudo.errors && emailLaudo.errors.maxlength"
            msgError="O e-mail laudo deve ter no máximo 100 caracteres">
          </sgt-form-control-error>
        </div>
      </div>
  
      <div class="row">
        <div class="form-group col-12 col-md-6" *ngIf="configEmpresa?.possuiClicheria">
          <label for="emailAprovacaoCliche" class="col-form-label">E-mail Responsável Aprovação do Clichê</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <a href="mailto:{{entity.emailAprovacaoCliche}}" class="btn btn-light" tabindex="-1">
                <i class="far fa-envelope" aria-hidden="true"></i>
              </a>
            </div>
            <input type="email" class="form-control" [(ngModel)]="entity.emailAprovacaoCliche" name="emailAprovacaoCliche" id="emailAprovacaoCliche"
              #emailAprovacaoCliche="ngModel" maxlength="100" [disabled]="!canEdit" [readonly]="!canEdit" sgtLowercase>
          </div>
          <sgt-form-control-error
            *ngIf="emailAprovacaoCliche.errors && emailAprovacaoCliche.errors.maxlength"
            msgError="O e-mail da aprovação do clichê deve ter no máximo 100 caracteres">
          </sgt-form-control-error>
        </div>
      </div>
    </sgt-accordion>
  </div>

  <!-- Canais Digitais -->
  <div class="mb-3">
    <sgt-accordion [settings]="{ isCollapsed: true, expanded: false }">
      <h6 header class="m-0">Canais Digitais</h6>
  
      <div class="row">
        <div class="form-group col-12">
          <label for="site" class="col-form-label">Site</label>
          <input type="url" class="form-control" [ngModel]="site" (ngModelChange)="onChangeSite($event)" name="site" id="site"
            #siteModel="ngModel" maxlength="500" [disabled]="!canEdit" [readonly]="!canEdit">
          <sgt-form-control-error
            *ngIf="siteModel.errors && siteModel.errors.maxlength"
            msgError="O site deve ter no máximo 500 caracteres">
          </sgt-form-control-error>
        </div>
      </div>
  
      <!-- E-Commerces -->
      <div class="row container-ecommerce" *ngIf="configCliente?.exibirEcommerces">
        <div class="col-12">
          <div class="row">
            <div class="form-group col-12">
              <label class="col-form-label">Marque abaixo as opções que o cliente possui</label>
              <div class="container-ecommerce-opcoes">
                <div class="custom-control custom-checkbox custom-control-inline">
                  <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.ecommerce" name="ecommerce" id="ecommerce" [disabled]="!canEdit">
                  <label class="custom-control-label" for="ecommerce">E-commerce?</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                  <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.mercadoLivre" name="mercadoLivre" id="mercadoLivre" [disabled]="!canEdit">
                  <label class="custom-control-label" for="mercadoLivre">Mercado Livre?</label>
                </div>
                <div class="custom-control custom-checkbox custom-control-inline">
                  <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.marketplace" name="marketplace" id="marketplace" [disabled]="!canEdit">
                  <label class="custom-control-label" for="marketplace">Marketplace?</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="possuiEcommerces()">
            <div class="col-12">
              <sgt-cliente-ecommerce
                [canEdit]="canEdit"
                [entities]="entity.eCommerces"
                #clienteECommerceCadastro>
              </sgt-cliente-ecommerce>
            </div>
          </div>
        </div>
      </div>
    </sgt-accordion>
  </div>   

</form>
